import useAppToast from '@/hooks/useAppToast';
import { createRezeptLimit, updateRezeptLimit, bulkCreateRezeptLimits } from '@/services/admin/rezeptLimitService';
import type { RezeptLimitFormData } from '@/types/admin-rezept-limit';
import { getApiErrorMessage } from '@/utils/apiError';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export const useCreateRezeptLimitMutation = (siteType: string) => {
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (data: RezeptLimitFormData) => createRezeptLimit(siteType, data),
    onSuccess: async () => {
      toast.success('更新しました。');
      await queryClient.invalidateQueries({ queryKey: ['rezept-limits', siteType] });
    },
    onError: error => {
      toast.error(getApiErrorMessage(error, 'エラーが発生しました。'));
    },
  });

  return { createMutation: mutateAsync, isPending };
};

export const useUpdateRezeptLimitMutation = (siteType: string) => {
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({ id, data }: { id: number; data: RezeptLimitFormData }) =>
      updateRezeptLimit(siteType, id, data),
    onSuccess: async () => {
      toast.success('更新しました。');
      await queryClient.invalidateQueries({ queryKey: ['rezept-limits', siteType] });
    },
    onError: error => {
      toast.error(getApiErrorMessage(error, 'エラーが発生しました。'));
    },
  });

  return { updateMutation: mutateAsync, isPending };
};

export const useBulkCreateRezeptLimitsMutation = (siteType: string) => {
  const toast = useAppToast();
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: (year: number) => bulkCreateRezeptLimits(siteType, year),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['rezept-limits', siteType] });
    },
    onError: error => {
      toast.error(getApiErrorMessage(error, 'エラーが発生しました。'));
    },
  });

  return { bulkCreateMutation: mutateAsync, isPending };
};
